import { render, staticRenderFns } from "./NightScreen.vue?vue&type=template&id=87d490c4&"
var script = {}
import style0 from "./NightScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NightScreen.vue"
export default component.exports